/* ==============================================
   KĀRU Product Widget JS
   Extracted from snippets/product-form.liquid
   ============================================== */

document.addEventListener('DOMContentLoaded', function() {

  /* ==============================================
     FETCH INTERCEPTOR – Selling Plan + Pre-Order Property
     ============================================== */
  (function() {
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        var spInput = document.getElementById('karu-selling-plan-input');
        var spValue = spInput ? spInput.value : '';

        var poInput = document.getElementById('karu-preorder-input');
        var poValue = (poInput && !poInput.disabled) ? poInput.value : '';

        if (options && options.body) {
          try {
            if (typeof options.body === 'string') {
              var data = JSON.parse(options.body);
              if (spValue) { data.selling_plan = parseInt(spValue); }
              else { delete data.selling_plan; }

              if (poValue) {
                data.properties = data.properties || {};
                data.properties['Vorbestellung'] = poValue;
              } else if (data.properties) {
                delete data.properties['Vorbestellung'];
              }

              options.body = JSON.stringify(data);
            } else if (options.body instanceof FormData) {
              if (spValue) { options.body.set('selling_plan', spValue); }
              else { options.body.delete('selling_plan'); }

              if (poValue) { options.body.set('properties[Vorbestellung]', poValue); }
              else { options.body.delete('properties[Vorbestellung]'); }
            }
          } catch(e) {}
        }
      }
      return originalFetch.apply(this, arguments);
    };
  })();

  /* ==============================================
     HELPERS
     ============================================== */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  /* Product Variants Data (für Preisanzeige) */
  var rawVariantsData = document.getElementById('karu-product-variants');
  var productVariants = rawVariantsData ? JSON.parse(rawVariantsData.textContent) : [];

  /* Pre-Order Data: { variant_id: "DD.MM.YYYY" } – leerer String = nicht aktiv */
  var rawPreorderData = document.getElementById('karu-preorder-data');
  var preorderData = {};
  if (rawPreorderData) {
    try { preorderData = JSON.parse(rawPreorderData.textContent) || {}; } catch(e) {}
  }

  function isPreorderVariant(variantId) {
    if (!variantId) return '';
    return preorderData[String(variantId)] || preorderData[parseInt(variantId)] || '';
  }

  /* Zentrale CTA-Aktualisierung: berücksichtigt Tab + Pre-Order-State.
     Daten-Attribute liegen auf dem BUTTON (überlebt Focal's loader-button Wrapping
     und PaymentContainer's innerHTML-Resets). Text wird in .loader-button__text
     geschrieben (falls vorhanden) oder direkt in den Button. */
  function updateCtaForCurrentState() {
    var btn = document.getElementById('AddToCart');
    if (!btn) return;
    var defaultTxt = btn.getAttribute('data-cta-default') || '';
    var preorderTxt = btn.getAttribute('data-cta-preorder') || 'Vorbestellen';

    var newTxt;
    if (typeof currentTab !== 'undefined' && currentTab === 'abo') {
      newTxt = (typeof ctaTextAbo !== 'undefined') ? ctaTextAbo : defaultTxt;
    } else {
      var preDate = isPreorderVariant(getActiveVariantId());
      newTxt = preDate ? preorderTxt : defaultTxt;
    }

    /* Text-Wrapper: Focal's loader-button wraped Button-Inhalt in .loader-button__text */
    var textWrapper = btn.querySelector('.loader-button__text') || btn;
    textWrapper.textContent = newTxt;

    /* data-button-content syncen – PaymentContainer liest das bei jedem variant:changed */
    btn.setAttribute('data-button-content', newTxt);
  }

  function updatePreorderUI(variantId) {
    var dateStr = isPreorderVariant(variantId);

    /* Hidden Input */
    var poInput = document.getElementById('karu-preorder-input');
    if (poInput) {
      if (dateStr) {
        poInput.value = 'Versand ab ' + dateStr;
        poInput.disabled = false;
      } else {
        poInput.value = '';
        poInput.disabled = true;
      }
    }

    /* Tax-Zeile vs. Pre-Order-Zeile umschalten */
    var taxEl = document.querySelector('[data-karu-tax-info]');
    var preEl = document.querySelector('[data-karu-preorder-info]');
    if (preEl) preEl.classList.toggle('is-hidden', !dateStr);
    if (taxEl) taxEl.classList.toggle('is-hidden', !!dateStr);

    /* Datum aktualisieren */
    var dateSpan = document.querySelector('[data-karu-preorder-date]');
    if (dateSpan && dateStr) dateSpan.textContent = dateStr;

    /* CTA-Button-Text via zentrale Funktion */
    updateCtaForCurrentState();
  }

  function findVariantById(id) {
    var numId = parseInt(id);
    return productVariants.find(function(v) { return v.id === numId; });
  }

  /* ==============================================
     PRE-ORDER: Variant-Level Listener (vor widget-Check)
     ============================================== */
  document.addEventListener('variant:changed', function(e) {
    var variantId = (e.detail && e.detail.variant && e.detail.variant.id) || null;
    if (!variantId) {
      var idInput = document.querySelector('form input[name="id"]:not([disabled])');
      if (idInput) variantId = idInput.value;
    }
    if (variantId) updatePreorderUI(variantId);
  });

  /* Read config from data attributes */
  var widget = document.getElementById('karu-widget');
  var formId = widget ? widget.getAttribute('data-form-id') : null;

  function getActiveVariantId() {
    var activeCard = document.querySelector('.karu-variant-card--active');
    if (activeCard) return activeCard.getAttribute('data-variant-id');

    var form = formId ? document.getElementById(formId) : null;
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    if (!idInput) idInput = document.querySelector('product-form input[name="id"]');
    if (!idInput) idInput = document.querySelector('form input[name="id"]:not([disabled])');
    return idInput ? idInput.value : null;
  }

  /* ==============================================
     VARIANT CARD ACTIVE STATE + VARIANT CHANGE
     ============================================== */
  var variantCards = document.querySelectorAll('.karu-variant-card');

  function syncCardActiveStates() {
    variantCards.forEach(function(card) {
      var radio = card.querySelector('.block-swatch__radio');
      if (radio) {
        card.classList.toggle('karu-variant-card--active', radio.checked);
      }
    });
  }

  function handleVariantCardChange(radio) {
    syncCardActiveStates();

    var card = radio.closest('.karu-variant-card');
    var variantId = card ? card.getAttribute('data-variant-id') : null;
    if (!variantId) return;

    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    /* Hidden input updaten */
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;

    /* URL updaten */
    if (history.replaceState) {
      var newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variantId);
      history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
    }

    /* variant:changed dispatchen für ProductMeta (Preisanzeige) */
    var variant = findVariantById(variantId);
    if (variant) {
      form.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }

    onVariantChanged();
  }

  if (variantCards.length > 0) {
    variantCards.forEach(function(card) {
      var radio = card.querySelector('.block-swatch__radio');
      if (!radio) return;
      radio.addEventListener('change', function() {
        handleVariantCardChange(radio);
      });
    });

    variantCards.forEach(function(card) {
      card.addEventListener('click', function() {
        var radio = card.querySelector('.block-swatch__radio');
        if (!radio) return;
        setTimeout(function() {
          if (radio.checked) {
            handleVariantCardChange(radio);
          }
        }, 0);
      });
    });
  }

  /* ==============================================
     UNIFIED WIDGET – Tab Switching + Abo Logic
     ============================================== */
  if (!widget) return;

  var tabs = widget.querySelectorAll('.karu-widget__tab');
  var aboInfo = document.getElementById('karu-abo-info');
  var frequencySelect = document.getElementById('karu-frequency-select');
  var sellingPlanInput = document.getElementById('karu-selling-plan-input');
  var rawData = document.getElementById('karu-selling-plans-data');
  var sellingPlansData = rawData ? JSON.parse(rawData.textContent) : {};
  var ctaTextAbo = widget.getAttribute('data-cta-abo') || 'Abo starten';
  var currentTab = 'once';

  /* Tab-Switch */
  function switchTab(tab) {
    currentTab = tab;

    /* Mode-Klasse fürs CSS: im Abo-Tab werden die Einmalkauf-Rabatt-Pills ausgeblendet */
    widget.classList.toggle('karu-widget--abo', tab === 'abo');

    tabs.forEach(function(t) {
      t.classList.toggle('karu-widget__tab--active', t.dataset.tab === tab);
    });

    if (aboInfo) {
      aboInfo.style.display = (tab === 'abo') ? 'block' : 'none';
    }

    updateCardPrices();

    if (tab === 'abo') {
      var variantId = getActiveVariantId();
      var vd = sellingPlansData[variantId];
      if (vd && vd.plans.length > 0) {
        populateFrequency(vd.plans);
        sellingPlanInput.value = vd.plans[0].id;
      }
    } else {
      if (sellingPlanInput) sellingPlanInput.value = '';
    }
    updateCtaForCurrentState();
  }

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      if (this.classList.contains('karu-widget__tab--disabled')) return;
      switchTab(this.dataset.tab);
    });
  });

  /* Card-Preise updaten basierend auf Tab */
  function updateCardPrices() {
    variantCards.forEach(function(card) {
      var priceEl = card.querySelector('.karu-variant-card__price');
      var compareEl = card.querySelector('[data-compare-display]');
      if (!priceEl) return;

      var oncePrice = parseInt(priceEl.getAttribute('data-once-price'));
      var aboPrice = priceEl.getAttribute('data-abo-price');

      if (currentTab === 'abo' && aboPrice) {
        priceEl.textContent = formatMoney(parseInt(aboPrice));
        if (compareEl) {
          compareEl.textContent = formatMoney(oncePrice);
          compareEl.style.display = '';
        }
      } else {
        priceEl.textContent = formatMoney(oncePrice);
        if (compareEl) {
          compareEl.style.display = 'none';
        }
      }
    });
  }

  /* Frequenz befüllen */
  function populateFrequency(plans) {
    if (!frequencySelect) return;
    var currentVal = frequencySelect.value;
    frequencySelect.innerHTML = '';
    plans.forEach(function(plan, i) {
      var opt = document.createElement('option');
      opt.value = plan.id;
      opt.textContent = plan.name;
      if (String(plan.id) === currentVal) opt.selected = true;
      else if (i === 0 && !currentVal) opt.selected = true;
      frequencySelect.appendChild(opt);
    });
  }

  /* Frequenz-Wechsel */
  if (frequencySelect) {
    frequencySelect.addEventListener('change', function() {
      if (sellingPlanInput) sellingPlanInput.value = this.value;
    });
  }

  /* Variante gewechselt → Abo-Tab prüfen + Pre-Order-State aktualisieren */
  function onVariantChanged() {
    var variantId = getActiveVariantId();
    var vd = sellingPlansData[variantId];
    var aboTab = widget.querySelector('[data-tab="abo"]');

    if (!vd || vd.plans.length === 0) {
      if (aboTab) aboTab.classList.add('karu-widget__tab--disabled');
      if (currentTab === 'abo') switchTab('once');
    } else {
      if (aboTab) aboTab.classList.remove('karu-widget__tab--disabled');
      if (currentTab === 'abo') {
        populateFrequency(vd.plans);
        sellingPlanInput.value = vd.plans[0].id;
      }
    }

    updateCardPrices();
    updatePreorderUI(variantId);
  }

  /* Theme variant:changed event (für externe Variantenwechsel, z.B. Farbswatches) */
  document.addEventListener('variant:changed', function() {
    syncCardActiveStates();
    onVariantChanged();
  });

  /* Initial */
  onVariantChanged();
  updateCardPrices();

});
